import { ICashRegisterGuiModel, ICashRegisterPutGuiModel, IOrganizationGuiModel, IOrganizationPutGuiModel, IPaymentMethodGuiModel } from "../model/IOrganizationGuiModel";
import ApproverService from "../service/ApproverService";
import OrganizationService from "../service/OrganizationService";
import { ICashRegisterModel, ICashRegisterPutModel, IOrganizationModel, IOrganizationPutModel, IPaymentMethodModel, IPaymentMethodPutModel } from "../service/model/IOrganizationModel";
import { BusinessLogicDefaultResult, BusinessLogicResult } from "./BusinessLogicResult";

export default class OrganizationBusinessLogic {

    public async getOrganizations(

    ): Promise<BusinessLogicResult<IOrganizationGuiModel[]>> {

        const service = new OrganizationService();
        const result = await service.getOrganizations();

        if (result.hasErrors) {
            return new BusinessLogicResult([], result.errors);
        } else {
            let apiData: IOrganizationModel[] = result.value;
            let data: IOrganizationGuiModel[] = apiData.map(e => {
                return {
                    id: e.id,
                    name: e.name,
                    customerNumber: e.customerNumber ? e.customerNumber : undefined,
                    organizationNumber: e.organizationNumber ? e.organizationNumber : undefined,
                    addressLine1: e.addressLine1 ? e.addressLine1 : undefined,
                    addressLine2: e.addressLine2 ? e.addressLine2 : undefined,
                    postalCode: e.postalCode ? e.postalCode : undefined,
                    postArea: e.postArea ? e.postArea : undefined,
                    bankAccount: e.bankAccount ? e.bankAccount.toString() : undefined,
                    iban: e.iban ? e.iban : undefined,
                    swift: e.swift ? e.swift : undefined,
                    companyRegistered: e.companyRegistered,
                    email: e.email ? e.email : undefined,
                    webSite: e.webSite ? e.webSite : undefined,
                    canCollectVAT: e.canCollectVAT,
                    phone: e.phone ? e.phone : undefined,
                    fax: e.fax ? e.fax : undefined,
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    }
    public async getOrganization(
        id: string
    ): Promise<BusinessLogicResult<IOrganizationGuiModel | undefined>> {

        const service = new OrganizationService();
        const result = await service.getOrganization(id);

        if (result.hasErrors) {
            return new BusinessLogicResult(undefined, result.errors);
        } else {
            let apiData: IOrganizationModel = result.value;
            let data: IOrganizationGuiModel = {
                id: apiData.id,
                name: apiData.name,
                customerNumber: apiData.customerNumber ? apiData.customerNumber : undefined,
                organizationNumber: apiData.organizationNumber ? apiData.organizationNumber : undefined,
                addressLine1: apiData.addressLine1 ? apiData.addressLine1 : undefined,
                addressLine2: apiData.addressLine2 ? apiData.addressLine2 : undefined,
                postalCode: apiData.postalCode ? apiData.postalCode : undefined,
                postArea: apiData.postArea ? apiData.postArea : undefined,
                bankAccount: apiData.bankAccount ? apiData.bankAccount.toString() : undefined,
                iban: apiData.iban ? apiData.iban : undefined,
                swift: apiData.swift ? apiData.swift : undefined,
                companyRegistered: apiData.companyRegistered,
                email: apiData.email ? apiData.email : undefined,
                webSite: apiData.webSite ? apiData.webSite : undefined,
                canCollectVAT: apiData.canCollectVAT,
                phone: apiData.phone ? apiData.phone : undefined,
                fax: apiData.fax ? apiData.fax : undefined,
            };
            return new BusinessLogicResult(data, result.errors);
        }
    }
    public async putOrganizationData(
        organizationId: string, data: IOrganizationGuiModel
    ): Promise<BusinessLogicDefaultResult> {

        const service = new OrganizationService();

        let apiData: IOrganizationPutModel = {
            name: data.name ? { value: data.name } : undefined,
            addressLine1: data.addressLine1 ? { value: data.addressLine1 ? data.addressLine1 : null } : undefined,
            addressLine2: data.addressLine2 ? { value: data.addressLine2 ? data.addressLine2 : null } : undefined,
            postalCode: data.postalCode ? { value: data.postalCode ? data.postalCode : null } : undefined,
            postArea: data.postArea ? { value: data.postArea ? data.postArea : null } : undefined,
            bankAccount: data.bankAccount ? { value: data.bankAccount ? parseInt(data.bankAccount) : null } : undefined,
            iban: data.iban ? { value: data.iban ? data.iban : null } : undefined,
            swift: data.swift ? { value: data.swift ? data.swift : null } : undefined,
            companyRegistered: { value: data.companyRegistered },
            email: data.email ? { value: data.email ? data.email : null } : undefined,
            webSite: data.webSite ? { value: data.webSite ? data.webSite : null } : undefined,
            canCollectVAT: { value: data.canCollectVAT },
            phone: data.phone ? { value: data.phone ? data.phone : null } : undefined,
            fax: data.fax ? { value: data.fax ? data.fax : null } : undefined,
        }

        const result = await service.putOrganizationData(organizationId, apiData);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async getCashRegisterSettings(
        organizationId: string
    ): Promise<BusinessLogicResult<ICashRegisterGuiModel | undefined>> {

        const service = new OrganizationService();
        const result = await service.getOrganizationCashRegister(organizationId);

        if (result.hasErrors) {
            return new BusinessLogicResult(undefined, result.errors);
        } else {
            let apiData: ICashRegisterModel = result.value;
            let data: ICashRegisterGuiModel = {
                withdrawalAccountId: apiData.withdrawalAccountId ? apiData.withdrawalAccountId.toString() : "",
                cashDifferenceAccountId: apiData.cashDifferenceAccountId ? apiData.cashDifferenceAccountId.toString() : "",
                giftCardAccountId: apiData.giftCardAccountId ? apiData.giftCardAccountId.toString() : ""
            };
            return new BusinessLogicResult(data, result.errors);
        }
    }
    public async putCashRegisterSettings(
        organizationId: string, data: ICashRegisterGuiModel
    ): Promise<BusinessLogicDefaultResult> {

        const service = new OrganizationService();

        let apiData: ICashRegisterPutModel = {
            withdrawlAccountId: { value: parseInt(data.withdrawalAccountId) },
            cashDifferenceAccountId: { value: parseInt(data.cashDifferenceAccountId) },
            giftCardAccountId: { value: parseInt(data.giftCardAccountId) },
        }

        const result = await service.putOrganizationCashRegisterData(organizationId, apiData);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async getCashRegisterPaymentMethods(
        organizationId: string
    ): Promise<BusinessLogicResult<IPaymentMethodGuiModel[]>> {

        const service = new OrganizationService();
        const result = await service.getOrganizationCashRegisterPaymentMethods(organizationId);

        if (result.hasErrors) {
            return new BusinessLogicResult([], result.errors);
        } else {
            let apiData: IPaymentMethodModel[] = result.value;
            let data: IPaymentMethodGuiModel[] = apiData.map(e => {
                return {
                    id: e.id,
                    name: e.name,
                    accountNo: e.accountNo.toString(),
                }
            })
            return new BusinessLogicResult(data, result.errors);
        }
    }
    public async postCashRegisterPaymentMethod(
        organizationId: string, name: string, accountNo: string,
    ): Promise<BusinessLogicDefaultResult> {

        const service = new OrganizationService();    

        const result = await service.postOrganizationCashRegisterPaymentMethod(organizationId, name, parseInt(accountNo));

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async putCashRegisterPaymentMethod(
        organizationId: string, id: number, name: string | undefined, accountNo: string | undefined,
    ): Promise<BusinessLogicDefaultResult> {

        const service = new OrganizationService();
        let data: IPaymentMethodPutModel = {
            name: name ? { value: name } : null,
            accountNo: accountNo ? {value: parseInt(accountNo)} : null,
        }

        const result = await service.putOrganizationCashRegisterPaymentMethodData(organizationId, id, data);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
}